<style scoped>
.padded {
  padding-left: 24px;
  padding-right: 24px;
}
.btn-checkout {
  background-color: #b03236;
  color: white;
}
.reward-btn {
  margin-bottom: 10px;
}

#tac-trigger {
  font-size: initial;
  color: blue;
}

.container {
  /* width: 85%; */
}

i.icon-header {
  font-size: 100px;
}

.text-emphasized {
  font-size: 1.1em;
  color: black;
  font-weight: bolder;
}
.empty-cart {
  text-align: center;
  height: 50vh;
  align-items: center;
  justify-content: center;
  display: flex;
}
.shop-now-btn {
  text-transform: none !important;
}
.center-div {
      display: flex !important;
    justify-content: center !important;
    margin: auto !important;
    max-width: 600px !important;
}
</style>
<template lang='pug'>
v-container(fluid)
  v-overlay(:value='loading')
    v-progress-circular(:size='70', :width='7', color='#b03236', indeterminate)
  .vspace.large
  transition
    .row.center-block.center-div(v-if='checkoutSuccess')
      .col.s12.m8.l6.offset-m2
        .card.center-align
          .card-content
            div
              i.icon-header.material-icons.green-text check_circle
            .vspace.small
            p.title.large Thank you!
            p.title.small Order #
              | {{ orderReferenceNumber }}
            .vspace.small
            p Your order has been submitted and is now being processed.
            p For inquiries, you may contact us at &nbsp;
              span.text-emphasized +63 917 318 0286 &nbsp;
              | or through our email: &nbsp;
              a.text-emphasized(href='mailto:admin@inom.ph') admin@inom.ph
            .vspace.small
    .empty-cart(v-else-if='hasItems.length <= 0')
      div
        h1.title.large Oops, Your Cart is Empty
        button.btn.waves-effect.shop-now-btn(@click='goToDrinks') Shop Now

    div(v-else)
      v-row.no-margin
        v-col(cols='12', sm='12')
          p.title.large Checkout
      v-row
        v-col.pr-lg-10.pr-md-5(cols='12', sm='12', md='6')
          page-cart-totals
          page-cart-items
        v-col.pr-lg-10.pl-md-5(cols='12', sm='12', md='6')
          page-cart-address
          .vspace.medium
          page-cart-payment
          a.btn.width100.white-text.mt-2(
            @click='checkout',
            :class='{ disabled: !canCheckout }'
          ) Checkout
  .vspace.large
</template>
<script>
import $ from 'jquery'
import AppTac from '@/components/app-tac'
import PageCartItems from '@/components/page-cart-items'
import PageCartTotals from '@/components/page-cart-totals'
import PageCartAddress from '@/components/page-cart-address'
import PageCartPayment from '@/components/page-cart-payment'

export default {
  meta: {
    title: 'Cart',
  },
  data() {
    return {
      iframeResized: false,
      referenceNumber: null,
      provinces: [],
      cities: [],
      checkoutMessage: null,
      checkingPromoCode: false,
      promoCodeCheckTimeout: null,
      promoCode: null,
      promoCodeValid: null,
      rewards: [],
      redeemableValues: [500, 1000, 2000],
      validatedPromoCodeKey: null,
      checkoutInProgress: false,
      checkoutError: null,
      checkoutUrl: null,
      useDefaultContactNumber: true,
      showTermsAndCond: false,
      checkoutSuccess: false,
      orderReferenceNumber: null,
      loading: false,
    }
  },
  created() {
    window.addEventListener('message', this.onPostMessage.bind(this))
  },
  computed: {
    canCheckout() {
      return this.$store.getters['cart/isValid']
    },
    hasItems() {
      return this.$store.state.cart.items
    },
  },
  watch: {
    checkoutError: function (error) {
      if (error) {
        this.$snackbar.error(error)
      }
    },
    user: function (user) {
      this.getRewards()
    },
  },
  mounted() {
    // const scriptURL = 'https://www.paypalobjects.com/api/checkout.js'
    // var scripts = document.getElementsByTagName('script')
    // for (let i = scripts.length; i--; ) {
    //   if (scripts[i].src == scriptURL) return
    // }

    // $.ajax({
    //   url: scriptURL,
    //   dataType: 'script',
    //   async: true
    // })
    this.$store.dispatch('config/getFees')
  },
  methods: {
    showTac() {
      this.showTermsAndCond = true
    },
    hideTac() {
      this.showTermsAndCond = false
    },
    onPostMessage: function (message) {
      if (
        message.origin.includes('localhost') ||
        message.origin.includes('api.inom.ph')
      ) {
        if (message.data.event === 'order-posted') {
          this.referenceNumber = message.data.referenceNumber
          this.checkoutMessage = message.data.additionalMessage
          this.checkoutUrl = null
          this.$store.commit('cart/resetState')
        } else if (message.data.event === 'checkout-cancelled') {
          this.checkoutUrl = null
        }
      }
    },
    goToDrinks() {
      this.$router.replace('drinks')
    },
    checkout() {
      this.loading = true
      return this.$store.dispatch('cart/checkout').then((order) => {
        this.orderReferenceNumber = order.referenceNumber
        this.checkoutSuccess = true
        this.$snackbar.success('Order submitted!')
        this.loading = false
      })
      // this.checkoutInProgress = true
      // return this.$store.dispatch('cart/checkout')
      //   .then(data => {
      //     this.checkoutInProgress = false
      //     this.checkoutUrl = data.checkoutUrl
      //   }).catch(err => {
      //     this.checkoutError = err.message || 'Unknown error occurred'
      //     this.checkoutInProgress = false
      //     this.$snackbar.error(err.message)
      //   })
    },
    resizeIframe: function (e) {
      const iframe = e.target
      const width = iframe.contentWindow.parent.document.body.offsetHeight
      iframe.style.width = $(this.$el)[0].offsetWidth + 'px'
      iframe.style.height = width + width / 4 + 'px'
      this.iframeResized = true
    },
  },
  components: {
    AppTac,
    PageCartItems,
    PageCartTotals,
    PageCartAddress,
    PageCartPayment,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/page-cart.vue